// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationDocumentsPage_wrapper__vZ5sX"};